export default __webpack_public_path__ + "static/media/money-back.0a4b78c0.png";